import styled, { css } from 'styled-components';
import { H3, Body } from 'components/Typography';
import addAlpha from 'utils/addAlpha';
import DefaultAreaChart from 'components/Charts/MultipleAreaChart';
import DefaultDatesSelector from 'components/Form/WeekRangePicker';
import {
  FiArrowDown as DefaultArrowDown,
  FiArrowUp as DefaultArrowUp,
} from 'react-icons/fi';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  margin-bottom: 6.1875rem;
`;

// TODO: TFR-44 move to container group
export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 6rem;
`;

// TODO: TFR-45:Title make unique name or do not export
export const Title = styled(H3)`
  margin-bottom: 1rem;
`;

// TODO: TFR-45:Header make unique name or do not export
export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
`;

// TODO: TFR-45:Date make unique name or do not export
export const DateCaption = styled(H3)`
  margin-right: 1.5rem;
`;

// TODO: TFR-45:Date make unique name or do not export
export const DatesSelector = styled(DefaultDatesSelector)``;

// TODO: TFR-44 move to container group
export const Section = styled.div`
  width: 100%;
  height: 17.625rem;
`;

// TODO: TFR-49 split components into two or more different logical components
export const Card = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  border-radius: 1rem;
  padding: 2.1875rem 2rem;
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const RatingCard = styled(Card)``;

export const HistoricalRatingCard = styled(Card)`
  height: 18rem;
`;

export const CommentsCard = styled(Card)`
  padding: 0;
`;

// TODO: TFR-44 move to container group
export const Row = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr 1fr 0.5fr;
  :not(:last-child) {
    margin-bottom: 1.3125rem;
  }
  > :nth-child(3n + 4),
  > :nth-child(3n + 2) {
    text-align: right;
  }
`;

// TODO: TFR-45:Name make unique name or do not export
export const Name = styled(Body)`
  font-weight: 600;
`;

// TODO: TFR-44 move to typography group
export const Number = styled(Body)`
  font-variant-numeric: tabular-nums;
`;

// TODO: TFR-44 move to typography group
export const Sales = styled(Number)`
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.6)};
`;

// TODO: TFR-45:Percentage make unique name or do not export
export const Percentage = styled.div<{ trend?: boolean }>`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  ${Number} {
    margin-left: 0.4375rem;
  }
  ${({ trend }) => {
    switch (trend) {
      case false:
        return css`
          ${Number} {
            color: ${({ theme }) => theme.colors.redMedium};
          }
        `;
      case true:
      default:
        return css`
          ${Number} {
            color: ${({ theme }) => theme.colors.greenMedium};
          }
        `;
    }
  }}
`;

// TODO: TFR-44 move to icon group
export const ArrowDownIcon = styled(DefaultArrowDown)`
  color: ${({ theme }) => theme.colors.redMedium};
`;

// TODO: TFR-44 move to icon group
export const ArrowUpIcon = styled(DefaultArrowUp)`
  color: ${({ theme }) => theme.colors.greenMedium};
`;

export const Rating = styled(Number)``;

// TODO: TFR-49 split components into two or more different logical components
export const AreaChart = styled(DefaultAreaChart)``;

// TODO: TFR-44 move to container group
export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 1rem;
`;
